import React, { useEffect } from 'react'
import ContactUsContainer from '../containers/ContactUs'
import Nav from '../components/nav/Nav';

const ContactUs: React.FC= () => {


  useEffect(() => {
    document.title = 'Elite Community CU | Contact Us';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "...Tuesday 7:45 a.m. 4:00 p.m. Wednesday CLOSED Thursday 7:45 a.m. 4:00 p.m. Friday 7:45 a.m. 4:00 p.m. Important NumbersABA#: 271985556NLMS#: 506334 ...";
    document.head.appendChild(metaDescription);
  }, []);


  return (
    <div>
      <Nav/>
      <ContactUsContainer />
    </div>
  )
}

export default ContactUs